// LetterTemplate

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { LETTER_TEMPLATE_API } from "../../constants/api";
import { useNavigate } from "react-router-dom";
import { FileSignature, Edit } from "lucide-react";
import { Button } from "../../components/ui/button";
import { cn } from "../../utils/tailwindUtils";
import { ContainerCard, ModuleTitleCard } from "../../components/ui/cards";
import { checkUserPermissionFunc } from "../../components/common/CommonFunctions";

const LetterTemplate = () => {

    const [LetterTemplateData, setLetterTemplateData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()

    const { add: addPermission, edit: editPermission, draft: draftPermission } = checkUserPermissionFunc('master', 'Letter Template', 'SubMenu')

    const LetterTemplateColumns = [
        {
            accessor: "code",
            Header: "Policy Code",
            sortable: true,
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "branch_name",
            Header: "Branch",
            sortable: true,
            filterable: true,
            Cell: ({ value }) => value || "-",
        },
        {
            accessor: "name",
            Header: "Template Name",
            sortable: true,
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "description",
            Header: "Description",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "is_active",
            Header: "Status",
            filterable: true,
            Cell: ({ value }) => (
                <span
                    className={cn(
                        "px-2 py-1 text-xs font-medium rounded-full",
                        value
                            ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                            : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
                    )}
                >
                    {value ? "Active" : "Inactive"}
                </span>
            ),
        },
        ...(editPermission ? [
            {
                accessor: "action",
                Header: "Action",
                sortable: false,
                Cell: ({ row }) => {
                    const handleOpenEdit = () => {
                        navigate("/master/lettertemplate/add", { state: { fromEdit: true, editDetails: row } })
                    };

                    return (
                        <div className="flex items-center gap-2">
                            {/* Edit Button */}
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-sidebar-primary hover:bg-blue-50 dark:hover:bg-gray-700"
                                onClick={handleOpenEdit}
                            >
                                <Edit className="h-4 w-4" />
                            </Button>
                        </div>
                    );
                },
            }
        ] : [])
    ];

    const handleLetterTemplate = () => {
        navigate('/master/lettertemplate/add')
    }

    return (
        <ContainerCard>
            {/* Header */}
            <ModuleTitleCard Icon={FileSignature} title={'Letter Template'} subtitle="Define different types of leave and time-off policies" totalRecords={totalRecords} buttonEnable={!!addPermission} setOpenDialog={handleLetterTemplate} buttonName={'Add Letter Template'} />

            <Reactable
                columns={LetterTemplateColumns}
                data={LetterTemplateData}
                setData={setLetterTemplateData}
                setTotalCount={setTotalRecords}
                url={LETTER_TEMPLATE_API}
                serverSide={true}
                rowSize={editPermission ? "sm" : null}
                isDraftRequired={!!draftPermission}
                isCSVRequired={true}
                isPDFRequired={true}
            />
        </ContainerCard >
    );
}

export default LetterTemplate;